import { Component, Input } from "@angular/core";

@Component({
    selector: "delivery-card-skeleton",
    templateUrl: "delivery-card-skeleton.component.html",
    styleUrls: ["delivery-card-skeleton.component.scss"],
})
export class DeliveryCardSkeletonComponent {
    @Input() mine: boolean;
}
